import { Component, OnInit } from '@angular/core';
import { WgisService } from '../wgis/wgis.service';

@Component({
  selector: 'app-appstore',
  templateUrl: './appstore.component.html',
})
export class AppstoreComponent implements OnInit {

  constructor(
    private wgisservice: WgisService,) {
    this.wgisservice.setMapInvisible();
  }

  ngOnInit() {
  }

}
